import { render, staticRenderFns } from "./TextDecimal.vue?vue&type=template&id=6fadcc8a"
import script from "./TextDecimal.vue?vue&type=script&lang=ts"
export * from "./TextDecimal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports